// extracted by mini-css-extract-plugin
export default {"component":"customerTargetPage__component___gr818","graph":"customerTargetPage__graph___aicBy","table":"customerTargetPage__table___lIcYr"};